import { useEffect } from 'react';

// Use this component for registering global keyboard shortcuts
// Not removing it for future reference
export function GlobalKeyboardShortcuts() {
  useEffect(() => {}, []);

  return null;
}
